import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5fb62d30"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "box card"
}
const _hoisted_2 = {
  key: 1,
  class: "animate"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { ref, onMounted } from 'vue'
import router from '@/router'
import useWindowWidth from '@/composables/useWindowWidth'


export default /*#__PURE__*/_defineComponent({
  __name: 'NoteRow',
  props: ['content', 'showOrder'],
  setup(__props) {

const {windowWidth} = useWindowWidth()

const props = __props
const card = ref({
    'id': 0,
    'content': 'cargando...',
    'lesson': 'cargando...',
    'course': 'cargando...',
    'date': 'cargando...',
    'course_id': 0,
    'lesson_id': 0
})
const loading = ref(true)

onMounted(() => {
    loading.value = true
    card.value = props.content
    loading.value = false
})

const handleRoute = () => router.push({name: 'course', params: {id: card.value.course_id, lesson_id: card.value.lesson_id}})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_icon, {
          name: "ri-loader-2-fill",
          animation: "spin",
          class: "icon"
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "card",
          onClick: handleRoute
        }, [
          _createElementVNode("h4", null, _toDisplayString(props.content.lesson), 1),
          _createElementVNode("p", null, [
            _createVNode(_component_v_icon, { name: "md-castforeducation" }),
            _createTextVNode(_toDisplayString(props.content.course) + " ", 1),
            _hoisted_3,
            _createVNode(_component_v_icon, { name: "md-daterange" }),
            _createTextVNode(_toDisplayString(new Date(props.content.date).getDate()) + " / " + _toDisplayString(new Date(props.content.date).getMonth()+1) + " / " + _toDisplayString(new Date(props.content.date).getFullYear()), 1)
          ])
        ])
      ]))
}
}

})